<template>
	<LoginLayout
		heading="Sign in to your account"
	>
		<template #form>
			<validation-observer
				v-if="!showOtpLinkSentScreen"
				#default="{ handleSubmit }"
				class="cassie-vertical-md"
			>
				<TextField
					v-model="username"
					rules="required"
					outlined
					label="Email Address *"
					placeholder="Please enter your email address"
				/>
				<PasswordField
					v-model="password"
					label="Password *"
				/>
				<v-card-actions class="pa-0">
					<v-row>
						<v-col cols="12">
							<v-btn
								:disabled="tryingToLogIn"
								:loading="tryingToLogIn"
								block
								color="primary"
								class="sign-in-button text-none"
								@click="handleSubmit(tryToLogIn)"
							>
								Sign In
							</v-btn>
						</v-col>
						<v-col
							cols="12"
							class="text-left py-2 pb-0"
						>
							<a
								href="#"
								class="forgotten-password-link"
								@click.prevent="navigateToForgottenPassword"
							>
								Forgotten Password?
							</a>
						</v-col>
					</v-row>
				</v-card-actions>
			</validation-observer>
			<div v-else>
				<p>
					You have been emailed a link to grant you access to Syrenis Customer Service Portal. Click the link in the email which will open a new tab in your browser.
				</p>
				<p>
					You can close this tab
				</p>
			</div>
		</template>
	</LoginLayout>
</template>

<script>
import { mapActions } from 'vuex'
import appConfig from '../../../app.config.json'
import LoginLayout from '../../../../../shared/layouts/login-layout.vue'
import PasswordField from '../../../../../shared/components/password-field.vue'
import { FORGOTTEN_PASSWORD, DATA_SUBJECT_SEARCH } from '../../../router/route-names.js'
import TextField from '../../../../../shared/components/text-field.vue'

export default {
	components: { TextField, LoginLayout, PasswordField },
	page: {
		title: 'Log in',
		meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }]
	},
	data () {
		return {
			username: '',
			password: '',
			showPassword: false,
			authError: null,
			tryingToLogIn: false,
			showOtpLinkSentScreen: false,
			formTitle: 'Sign In'
		}
	},
	methods: {
		...mapActions('auth', ['logIn', 'logOut']),
		// Try to log the user in with the username
		// and password they provided.
		tryToLogIn () {
			this.tryingToLogIn = true
			// Reset the authError if it existed.
			this.authError = null
			this.logIn({
				username: this.username,
				password: this.password
			})
				.then(response => {
					this.tryingToLogIn = false
					if (response != null) {
						this.showOtpLinkSentScreen = response.otpLoginRequired
						if (this.showOtpLinkSentScreen) {
							this.formTitle = 'Link has been sent'
							return
						}
					}
					// Redirect to the originally requested page, or to the home page
					this.$router.push(
						this.$route.query.redirectFrom || { name: DATA_SUBJECT_SEARCH }
					)
				})
				.catch(error => {
					if (error.message === 'Account locked out') {
						this.$router.push({ name: 'account-locked-out' })
					} else if (error.message === '403') {
						this.$router.push({ name: 'direct-login-not-allowed' })
					}
					this.tryingToLogIn = false
					this.authError = error
				})
		},
		navigateToForgottenPassword () {
			this.$router.push({ name: FORGOTTEN_PASSWORD })
		}
	}
}
</script>

<style scoped>
.forgotten-password-link {
	text-decoration: none;
	color: var(--global-foreground, #000);
	font-size: 0.875rem;
}
</style>
